export const DASHBOARD_COUNTRIES = {
  "United States": { code: "US" },
  India: { code: "IN" },
  Afghanistan: { code: "AF" },
  "Aland Islands": { code: "AX" },
  Albania: { code: "AL" },
  Algeria: { code: "DZ" },
  "American Samoa": { code: "AS" },
  Andorra: { code: "AD" },
  Angola: { code: "AO" },
  Anguilla: { code: "AI" },
  Antarctica: { code: "AQ" },
  "Antigua and Barbuda": { code: "AG" },
  Argentina: { code: "AR" },
  Armenia: { code: "AM" },
  Aruba: { code: "AW" },
  Australia: { code: "AU" },
  Austria: { code: "AT" },
  Azerbaijan: { code: "AZ" },
  Bahamas: { code: "BS" },
  Bahrain: { code: "BH" },
  Bangladesh: { code: "BD" },
  Barbados: { code: "BB" },
  Belarus: { code: "BY" },
  Belgium: { code: "BE" },
  Belize: { code: "BZ" },
  Benin: { code: "BJ" },
  Bermuda: { code: "BM" },
  Bhutan: { code: "BT" },
  "Bolivia, Plurinational State of bolivia": { code: "BO" },
  "Bosnia and Herzegovina": { code: "BA" },
  Botswana: { code: "BW" },
  "Bouvet Island": { code: "BV" },
  Brazil: { code: "BR" },
  "British Indian Ocean Territory": { code: "IO" },
  "Brunei Darussalam": { code: "BN" },
  Bulgaria: { code: "BG" },
  "Burkina Faso": { code: "BF" },
  Burundi: { code: "BI" },
  Cambodia: { code: "KH" },
  Cameroon: { code: "CM" },
  Canada: { code: "CA" },
  "Cayman Islands": { code: "KY" },
  "Central African Republic": { code: "CF" },
  Chad: { code: "TD" },
  Chile: { code: "CL" },
  China: { code: "CN" },
  "Christmas Island": { code: "CX" },
  "Cocos (Keeling) Islands": { code: "CC" },
  Colombia: { code: "CO" },
  Comoros: { code: "KM" },
  Congo: { code: "CG" },
  "Congo, The Democratic Republic of the Congo": { code: "CD" },
  "Cook Islands": { code: "CK" },
  "Costa Rica": { code: "CR" },
  "Cote d'Ivoire": { code: "CI" },
  Croatia: { code: "HR" },
  Cuba: { code: "CU" },
  Cyprus: { code: "CY" },
  "Czech Republic": { code: "CZ" },
  Denmark: { code: "DK" },
  Djibouti: { code: "DJ" },
  Dominica: { code: "DM" },
  "Dominican Republic": { code: "DO" },
  Ecuador: { code: "EC" },
  Egypt: { code: "EG" },
  "El Salvador": { code: "SV" },
  "Equatorial Guinea": { code: "GQ" },
  Eritrea: { code: "ER" },
  Estonia: { code: "EE" },
  Ethiopia: { code: "ET" },
  "Falkland Islands (Malvinas)": { code: "FK" },
  "Faroe Islands": { code: "FO" },
  Fiji: { code: "FJ" },
  Finland: { code: "FI" },
  France: { code: "FR" },
  "French Guiana": { code: "GF" },
  "French Polynesia": { code: "PF" },
  "French Southern Territories": { code: "TF" },
  Gabon: { code: "GA" },
  Gambia: { code: "GM" },
  Georgia: { code: "GE" },
  Germany: { code: "DE" },
  Ghana: { code: "GH" },
  Gibraltar: { code: "GI" },
  Greece: { code: "GR" },
  Greenland: { code: "GL" },
  Grenada: { code: "GD" },
  Guadeloupe: { code: "GP" },
  Guam: { code: "GU" },
  Guatemala: { code: "GT" },
  Guernsey: { code: "GG" },
  Guinea: { code: "GN" },
  "Guinea-Bissau": { code: "GW" },
  Guyana: { code: "GY" },
  Haiti: { code: "HT" },
  "Heard Island and Mcdonald Islands": { code: "HM" },
  "Holy See (Vatican City State)": { code: "VA" },
  Honduras: { code: "HN" },
  "Hong Kong": { code: "HK" },
  Hungary: { code: "HU" },
  Iceland: { code: "IS" },
  Indonesia: { code: "ID" },
  "Iran, Islamic Republic of Persian Gulf": { code: "IR" },
  Iraq: { code: "IQ" },
  Ireland: { code: "IE" },
  "Isle of Man": { code: "IM" },
  Israel: { code: "IL" },
  "Campione d'Italia": { code: "IT" },
  Jamaica: { code: "JM" },
  Japan: { code: "JP" },
  Jersey: { code: "JE" },
  Jordan: { code: "JO" },
  Kazakhstan: { code: "KZ" },
  Kenya: { code: "KE" },
  Kiribati: { code: "KI" },
  "Korea, Democratic People's Republic of Korea": { code: "KP" },
  "Korea, Republic of South Korea": { code: "KR" },
  Kuwait: { code: "KW" },
  Kyrgyzstan: { code: "KG" },
  Laos: { code: "LA" },
  Latvia: { code: "LV" },
  Lebanon: { code: "LB" },
  Lesotho: { code: "LS" },
  Liberia: { code: "LR" },
  "Libyan Arab Jamahiriya": { code: "LY" },
  Liechtenstein: { code: "LI" },
  Lithuania: { code: "LT" },
  Luxembourg: { code: "LU" },
  Macao: { code: "MO" },
  Macedonia: { code: "MK" },
  Madagascar: { code: "MG" },
  Malawi: { code: "MW" },
  Malaysia: { code: "MY" },
  Maldives: { code: "MV" },
  Mali: { code: "ML" },
  Malta: { code: "MT" },
  "Marshall Islands": { code: "MH" },
  Martinique: { code: "MQ" },
  Mauritania: { code: "MR" },
  Mauritius: { code: "MU" },
  Mayotte: { code: "YT" },
  Mexico: { code: "MX" },
  "Micronesia, Federated States of Micronesia": { code: "FM" },
  Moldova: { code: "MD" },
  Monaco: { code: "MC" },
  Mongolia: { code: "MN" },
  Montenegro: { code: "ME" },
  Montserrat: { code: "MS" },
  Morocco: { code: "MA" },
  Mozambique: { code: "MZ" },
  Myanmar: { code: "MM" },
  Namibia: { code: "NA" },
  Nauru: { code: "NR" },
  Nepal: { code: "NP" },
  Netherlands: { code: "NL" },
  "New Caledonia": { code: "NC" },
  "New Zealand": { code: "NZ" },
  Nicaragua: { code: "NI" },
  Niger: { code: "NE" },
  Nigeria: { code: "NG" },
  Niue: { code: "NU" },
  "Norfolk Island": { code: "NF" },
  "Northern Mariana Islands": { code: "MP" },
  Norway: { code: "NO" },
  Oman: { code: "OM" },
  Pakistan: { code: "PK" },
  Palau: { code: "PW" },
  "Palestinian Territory, Occupied": { code: "PS" },
  Panama: { code: "PA" },
  "Papua New Guinea": { code: "PG" },
  Paraguay: { code: "PY" },
  Peru: { code: "PE" },
  Philippines: { code: "PH" },
  Pitcairn: { code: "PN" },
  Poland: { code: "PL" },
  Portugal: { code: "PT" },
  "Puerto Rico": { code: "PR" },
  Qatar: { code: "QA" },
  Romania: { code: "RO" },
  Russia: { code: "RU" },
  Rwanda: { code: "RW" },
  Reunion: { code: "RE" },
  "Saint Barthelemy": { code: "BL" },
  "Saint Helena, Ascension and Tristan Da Cunha": { code: "SH" },
  "Saint Kitts and Nevis": { code: "KN" },
  "Saint Lucia": { code: "LC" },
  "Saint Martin": { code: "MF" },
  "Saint Pierre and Miquelon": { code: "PM" },
  "Saint Vincent and the Grenadines": { code: "VC" },
  Samoa: { code: "WS" },
  "San Marino": { code: "SM" },
  "Sao Tome and Principe": { code: "ST" },
  "Saudi Arabia": { code: "SA" },
  Senegal: { code: "SN" },
  Serbia: { code: "RS" },
  Seychelles: { code: "SC" },
  "Sierra Leone": { code: "SL" },
  Singapore: { code: "SG" },
  Slovakia: { code: "SK" },
  Slovenia: { code: "SI" },
  "Solomon Islands": { code: "SB" },
  Somalia: { code: "SO" },
  "South Africa": { code: "ZA" },
  "South Sudan": { code: "SS" },
  "South Georgia and the South Sandwich Islands": { code: "GS" },
  Spain: { code: "ES" },
  "Sri Lanka": { code: "LK" },
  Sudan: { code: "SD" },
  Suriname: { code: "SR" },
  "Svalbard and Jan Mayen": { code: "SJ" },
  Eswatini: { code: "SZ" },
  Sweden: { code: "SE" },
  Switzerland: { code: "CH" },
  "Syrian Arab Republic": { code: "SY" },
  Taiwan: { code: "TW" },
  Tajikistan: { code: "TJ" },
  "Tanzania, United Republic of Tanzania": { code: "TZ" },
  Thailand: { code: "TH" },
  "Timor-Leste": { code: "TL" },
  Togo: { code: "TG" },
  Tokelau: { code: "TK" },
  Tonga: { code: "TO" },
  "Trinidad and Tobago": { code: "TT" },
  Tunisia: { code: "TN" },
  Turkey: { code: "TR" },
  Turkmenistan: { code: "TM" },
  "Turks and Caicos Islands": { code: "TC" },
  Tuvalu: { code: "TV" },
  Uganda: { code: "UG" },
  Ukraine: { code: "UA" },
  "United Arab Emirates": { code: "AE" },
  "United Kingdom": { code: "GB" },
 
  Uruguay: { code: "UY" },
  Uzbekistan: { code: "UZ" },
  Vanuatu: { code: "VU" },
  "Venezuela, Bolivarian Republic of Venezuela": { code: "VE" },
  Vietnam: { code: "VN" },
  "Virgin Islands, British": { code: "VG" },
  "Virgin Islands, U.S.": { code: "VI" },
  "Wallis and Futuna": { code: "WF" },
  Yemen: { code: "YE" },
  Zambia: { code: "ZM" },
  Zimbabwe: { code: "ZW" },
};

export const DASHBOARD_COUNTRY_OPTIONS = [
  { label: "All Countries", value: "all" },
  ...Object.entries(DASHBOARD_COUNTRIES).map(([label, { code }]) => ({
    label,
    value: code.toLowerCase(),
  })),
];

export const normalizeCountryCode = (countryCode) => {
  if (!countryCode || countryCode === "all") return "all";
  if (countryCode.toLowerCase() === "uk") return "gb";
  return countryCode.toLowerCase();
};
